import React from 'react';
import { Clock } from 'lucide-react';

interface SessionTimeoutModalProps {
  show: boolean;
  secondsLeft: number;
  onStaySignedIn: () => void;
  onLogout: () => void;
}

const formatCountdown = (totalSeconds: number): string => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

const SessionTimeoutModal: React.FC<SessionTimeoutModalProps> = ({ show, secondsLeft, onStaySignedIn, onLogout }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm transition-opacity">
      <div
        role="alertdialog"
        aria-labelledby="session-timeout-title"
        className="w-full max-w-md rounded-xl bg-[#1c1c1c] p-6 text-white shadow-2xl border border-gray-700 mx-4"
      >
        <div className="flex items-center gap-3 border-b border-gray-700 pb-3 mb-4">
          <Clock className="w-5 h-5 text-orange-400" />
          <h3 id="session-timeout-title" className="text-lg font-semibold">
            Your session is about to expire
          </h3>
        </div>

        <p className="text-sm text-gray-300 mb-2">You've been inactive for a while. For your security, you'll be logged out in</p>
        <p className="text-3xl font-semibold text-orange-400 mb-5 tabular-nums" aria-live="polite">
          {formatCountdown(secondsLeft)}
        </p>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onLogout}
            className="px-5 py-2 border border-gray-600 rounded-full text-gray-300 hover:bg-gray-700 transition-all"
          >
            Log out now
          </button>
          <button
            onClick={onStaySignedIn}
            className="px-5 py-2 bg-red-700 hover:bg-red-800 rounded-full font-medium transition-all text-white"
          >
            Stay signed in
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;
